.trigger {
  width: 100%;
  min-width: 0;
  justify-content: space-between;
  padding: 0.625rem 0.75rem;
  border: 1px solid var(--color-border) !important;
  border-radius: var(--radius-md);
  background: var(--color-surface-subtle) !important;
  transition:
    border-color 140ms ease,
    background 140ms ease;

  &:hover {
    border-color: var(--color-primary-border) !important;
    background: var(--color-surface-raised) !important;
  }

  > svg {
    width: 1rem;
    height: 1rem;
    color: var(--color-muted-foreground);
  }
}

.triggerProject {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 0.625rem;
}

.projectText {
  display: flex;
  min-width: 0;
  flex-direction: column;
  align-items: flex-start;
  line-height: 1.2;
}

.projectName {
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: var(--color-foreground);
  font-size: var(--text-sm);
  font-weight: 600;
}

.projectDescription {
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: var(--color-muted);
  font-size: var(--text-xs);
}

.content {
  width: min(24rem, calc(100vw - 1.5rem));
  max-height: min(40rem, calc(100dvh - 2rem));
}

.projectListViewport {
  max-height: min(14rem, 35dvh);
  overflow-y: auto;
  padding: 0.375rem 0.5rem;
}

.selectedIcon {
  color: var(--color-primary);
}
